module.exports = __webpack_public_path__ + "img/3.3fd40a02.jpg";